export type TileType = "land" | "ocean" | "tree";

export class Tile {

    img: string;
    type: TileType;

    constructor(img: string, type: TileType) {
        this.img = img;
        this.type = type;
    }
}